/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OeamtcCaseCreateRequestResponse } from '../../models/oeamtc-case-create-request-response';

export interface CreateRoadsideAssistanceCase$Params {
      body: OeamtcCaseCreateRequestResponse
}

export function createRoadsideAssistanceCase(http: HttpClient, rootUrl: string, params: CreateRoadsideAssistanceCase$Params, context?: HttpContext): Observable<StrictHttpResponse<OeamtcCaseCreateRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, createRoadsideAssistanceCase.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OeamtcCaseCreateRequestResponse>;
    })
  );
}

createRoadsideAssistanceCase.PATH = '/api/v1/extensions/tenants/oeamtc/cases';
